// @flow

import Grid from '@mui/material/Grid2';
import React from "react";

type Props = {};

const InfoGrid = ({ label, children }: Props) => {
	return (
		<Grid
			container spacing={1}
			sx={{ pb: 1, pt: 1, borderBottom: '1px solid #9DC2E5' }}
		>
			<Grid size={{xs: 12, sm: 6}} sx={{ fontSize: {xs: '1.2rem', sx: '1.3rem'} }}>
				{label}
			</Grid>
			<Grid
				size={{xs: 12, sm: 6}}
				sx={{ fontWeight: 'bold', fontSize: {xs: '1.3rem', md: '1.4rem'}, wordBreak: 'break-word' }}
			>
				{children}
			</Grid>
		</Grid>
	);
};

export default InfoGrid